import script from "./Hotkeys.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hotkeys.vue?vue&type=script&setup=true&lang=ts"

import "./Hotkeys.vue?vue&type=style&index=0&id=5b4ec2e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4ec2e0"]])

export default __exports__